import React, { lazy, Suspense, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { Loading, LoadingLayout, Layout } from 'common/components/layout';
import { retry } from 'common/helpers/routerHelper';
import { getProduct } from 'redux/products/actions';
import { getProductBySlug } from 'redux/products/reducers';

import NotFound from './notFound/NotFound';

const LoadableComponent = lazy(() => retry(() => import('./Product')));

const ProductLoader = () => {
  const [isNotFound, setNotFound] = useState(false);
  const dispatch = useDispatch();
  const params = useParams();
  const { slug } = params;

  const productReducer = useSelector((state) => state.product);
  const product = getProductBySlug(productReducer, slug);

  useEffect(() => {
    const onError = () => {
      setNotFound(true);
    };
    dispatch(getProduct(slug, onError));
  }, [dispatch, slug]);

  if (isNotFound) {
    return <NotFound />;
  }

  if (productReducer.isObjectFetching || !product) {
    return <LoadingLayout />;
  }

  return (
    <Layout title={product.seo.title} description={product.seo.description}>
      <Suspense fallback={<Loading />}>
        <LoadableComponent />
      </Suspense>
    </Layout>
  );
};

export default ProductLoader;
